import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const NoTie = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="m20 15.633-5.061-3.036a2.944 2.944 0 0 0 0-1.195L20 8.365v7.268Zm-16 0V8.365l5.061 3.037a2.934 2.934 0 0 0 0 1.195L4 15.633Zm17.228-9.436a1.529 1.529 0 0 0-1.535.02l-5.795 3.477A2.972 2.972 0 0 0 12 8.999c-.725 0-1.38.268-1.898.696L4.306 6.217a1.527 1.527 0 0 0-1.534-.02A1.53 1.53 0 0 0 2 7.524v8.95a1.52 1.52 0 0 0 2.307 1.306l5.795-3.475a2.971 2.971 0 0 0 1.898.694c.725 0 1.38-.267 1.898-.695l5.796 3.477A1.52 1.52 0 0 0 22 16.475V7.524a1.53 1.53 0 0 0-.772-1.327Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default NoTie;
